
import React from "react";
import { Modal, Button} from "react-bootstrap";

import imgWarning from "../../assets/alert-warning.png";
export default function PopUpConfirmLogout({ open, onClose, onSubmit }) {
  // state

  // useEffect

  return (
    <Modal show={open} onHide={onClose} size="sm" centered>
      <Modal.Body
        style={{
          boxSizing: "border-box",
          overflow: "auto",
          width: "100%",
          padding: 20,
          paddingBottom: 0,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h1 style={{ color: "#343A40", fontSize: 20, fontWeight: 700 }}>
            ອອກຈາກລະບົບ!
          </h1>
          <p style={{ color: "#6C757D", fontSize: 16 }}>
            ທ່ານຕ້ອງການອອກຈາກລະບົບແທ້ບໍ
          </p>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={imgWarning}
            alt=""
            style={{ width: 150, margin: "20px 0" }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div
          style={{
            display: "grid",
            gap: 10,
            gridTemplateColumns: "1fr 1fr",
            width: "100%",
          }}
        >
          <Button
            variant="outline-primary"
            size="md"
            onClick={onClose}
            style={{ minWidth: 0 }}
          >
            ຍົກເລີກ
          </Button>
          <Button
            variant="primary"
            size="md"
            style={{ minWidth: 0 }}
            onClick={onSubmit}
          >
            ອອກ
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}